import { History } from "history";

import {
  TOGGLE_BLOCK_USER,
  TOGGLE_BLOCK_USER_CONSENT,
  TOGGLE_BLOCK_USER_ERROR,
  TOGGLE_BLOCK_USER_SUCCESS,
  ToggleBlockUserAction,
  ToggleBlockUserConsentAction,
  ToggleBlockUserErrorAction,
  ToggleBlockUserSuccessAction,
} from "./actionTypes";
import {} from "../../city/actionTypes";

//#region Toggle Block User

export const toggleBlockUserConsent = (
  id: string
): ToggleBlockUserConsentAction => {
  return {
    type: TOGGLE_BLOCK_USER_CONSENT,
    payload: id,
  };
};

export const toggleBlockUser = (
  id: string,
  state: boolean,
  history: History
): ToggleBlockUserAction => {
  return {
    type: TOGGLE_BLOCK_USER,
    payload: { id, state, history },
  };
};

export const toggleBlockUserSuccess = (): ToggleBlockUserSuccessAction => {
  return {
    type: TOGGLE_BLOCK_USER_SUCCESS,
    payload: null,
  };
};

export const toggleBlockUserError = (
  error: any
): ToggleBlockUserErrorAction => {
  return {
    type: TOGGLE_BLOCK_USER_ERROR,
    payload: error,
  };
};

//#endregion
